module.exports = __webpack_public_path__ + "static/media/title.2f38c74b.png";